import { tokenStore } from './tokenStore';

export async function authFetch(url, options = {}, explicitToken = null) {
  const token = explicitToken || tokenStore.get();

  const headers = {
    ...(options.headers || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const newOptions = {
    ...options,
    headers,
  };

  return fetch(url, newOptions);
}
